import { AppSize, ngStates, PropertyType, pxToRem } from "@/util";
import { Box, Button, Divider, IconButton, InputAdornment, Paper, TextField, Typography ,useMediaQuery,useTheme} from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Image from "next/image";
import { AppColors } from "@/assets/colors";
import InputSelect from "../global/select";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from '@mui/icons-material/Tune';
import Drawer from "../home/drawer";
import PortfolioFilter from "../filter/portfolio";
type optionsType ={ 
  name: string;
  placeholder: string,
  data:{label:string,value:string}[],
  value:string,
  handleChange:(e:string)=>void,
  type:string,
  
}; 

type props={
  handleSearch:()=>void,
  location:string,
  setLocation:(e:string)=>void,
  setPropertyType:(e:string)=>void,
  propertyType:string,
  year:string,
  setYear:(e:string)=>void,
  sort:string,
  setSort:(e:string)=>void,
  propertyName:string,
  setPropertyName:(e:string)=>void
}
export default function Expolore({propertyName="",setPropertyName,location,setLocation,propertyType,setPropertyType,year,setYear,setSort,sort,handleSearch}:Partial<props>) {
  const { classes } = styles();
 const theme=useTheme();
 const isMobile = useMediaQuery(theme.breakpoints.down(860));
  const [openFilt,setOpenFilt]=React.useState<boolean>(false);
  

  const options:Partial<optionsType>[] = [
    { 
      name: "Location", 
      placeholder: "City",
       data:ngStates.map((item) => ({ value: item.name, label: item.name })),
       type:"select" ,
       handleChange:(e:string)=>setLocation&&setLocation(e),
       value:location
      },
    { 
      name: "Property",
       placeholder: "Residential", 
       data:Object.keys(PropertyType).map(key => ({ label: key, value: key })),
       type:"select",
       handleChange:(e:string)=>setPropertyType&&setPropertyType(e),
       value:propertyType
       },
    // { name: "Price Range", placeholder: "Price Range" },
    { 
      name: "Year", 
      placeholder: "Completed",
      type:"text",
      handleChange:(e:string)=>setYear&&setYear(e),
      value:year
     },
    {
       name: "Sort",
      placeholder: "Newest",
      type: "select",
      data: [{ label: "Newest", value: "newest" }, { label: "Oldest", value: "oldest" }],
      handleChange: (e: string) =>setSort&&setSort(e),
      value:sort
     },
  ];
  

  

  return (
    <Box className={`${classes.container} `}>
      <Box className={`${classes.bgImg}`}>
        <Image
          src="/images/home/curated protfolio.svg"
          alt="discover"
          objectFit="cover"
          fill={true}
        />
      </Box>
      <Box className={`${classes.sub}`}>
        <Box className={`${classes.top}`}>
          <Typography className={classes.headTxt}>
            Explore Our Curated Project Portfolio
          </Typography>
          <Typography className={classes.detTxt}>
            Discover our collection of premium properties, from completed luxury
            homes to upcoming investment opportunities
          </Typography>
        </Box>
        <Box className={`${classes.foot}`}>
          <Paper className={classes.drop} elevation={2}>
            {options.map((option, key) => (
              <Box className={classes.dropCont} key={key}>
                <Box style={{ width: "100%" }}>
                  <Typography className={classes.selectName}>
                    {option.name}
                  </Typography>
                  {option.type==="text"&&
                  <TextField 
                  placeholder={option.placeholder}
                   value={option.value}
                    onChange={(e)=>option.handleChange && option.handleChange(e.target.value)}
                    size="small"
                    variant="standard"
                    />}
                  {option.type==="select"&&
                  <InputSelect
                    value={option.value}
                    placeholder={option.placeholder}
                    data={option.data}
                    
                    handleChange={(e) => option.handleChange && option.handleChange(e.target.value)}
                    // className={classes.placeholders}
                  />
                  }
                  
                </Box>
                {key < options.length - 1 && (
                  <Divider orientation="vertical" className={classes.divider} />
                )}
              </Box>
            ))}
           
            <Button
              className={classes.btn}
              startIcon={<SearchIcon fontSize="large" />}
              variant="contained"
              onClick={()=>handleSearch&&handleSearch()}
            >
              Apply Filter
            </Button>
          </Paper>
        </Box>
        
            <Drawer open={isMobile&& openFilt} anchor="bottom">
          <PortfolioFilter handleSearch={()=>handleSearch?handleSearch():undefined} setSort={(e)=>setSort&&setSort(e)} sort={sort} isPriceRange={false} isStatus={false} setPropertyType={(e:string)=>setPropertyType&&setPropertyType(e)} propertyType={propertyType&&propertyType} location={location} setLocation={(e)=>setLocation&&setLocation(e)}  handleClose={()=>setOpenFilt(false)}/>
            </Drawer>
         
         
        <Box className={`${classes.mobileNav}`}>
          <Paper className={`${classes.mobile}`} elevation={2}>
            <TextField
                className={classes.input}
                variant="outlined"
                placeholder="Search for Property"
                value={propertyName}
                onChange={(e)=>setPropertyName&&setPropertyName(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton aria-label="search"
                      onClick={()=>handleSearch&&handleSearch()}
                      >
                        <SearchIcon 
                          fontSize="large"
                          className={classes.searchIcon}
                         
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                  endAdornment:(
                     <InputAdornment position="start">
                      <IconButton aria-label="search"
            
                       onClick={()=>setOpenFilt(true)}
                      >
                        <TuneIcon 
                          fontSize="large"
                          className={classes.searchIcon}
                         
                        />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
          </Paper>
        </Box>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: pxToRem(634),
    position: "relative",
    /** [theme.breakpoints.down(600)]:{
     minHeight: pxToRem(400),
    },  */
  },
  
  input: {
    color: AppColors.neutral["73"],
    fontFamily: "Playfair Display",
    fontWeight: 400,
    fontSize: pxToRem(16),
    borderRadius: pxToRem(8),
    width: "100%",
    // Standard input styles
    "& .MuiInput-root, & .MuiFilledInput-root": {
      border: "none",
      "&:before, &:after": {
        borderBottom: "none !important",
      },
    },
    "& .MuiInputBase-root": {
      height: "100%", // Set the height here for the root element
      border: "none",
    },
    "& .MuiOutlinedInput-input": {
      // padding: pxToRem(14), // Adjust padding if necessary to align content properly
      border: "none",
    },
  },
  searchIcon: {
    fontSize: pxToRem(20),
  },
  debug: {
    border: `1px solid green`,
  },
  bgImg: {
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: -1,
  },
  sub: {
    width: "100%",
    height: "100%",
    display: "grid",
    gridTemplateRows: "3fr 1fr",
    flex: 1,
  },
  headTxt: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(60),
    width: "40%",
    color: theme.colors.white,
    lineHeight: "120%",
    [theme.breakpoints.down(1360)]: {
      fontSize: pxToRem(55),
      width: "60%",
      lineHeight: "120%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      fontSize: pxToRem(35),
    },
    [theme.breakpoints.down(795)]: {
      fontSize: pxToRem(40),
      width: "100%",
    },
    [theme.breakpoints.down(436)]: {
      fontSize: pxToRem(30),
      width: "100%",
    },
  },
  detTxt: {
    color: AppColors.neutral["90"],
    fontWeight: 400,
    fontSize: pxToRem(20),
    width: "40%",
    lineHeight: "160%",
    [theme.breakpoints.down(1360)]: {
      fontSize: pxToRem(18),
      width: "55%",
      fontWeight: 100,
      lineHeight: "160%",
    },
    [theme.breakpoints.down(795)]: {
      width: "100%",
    },
  },
  placeholders: {
    color: "#6A6A6A",
    fontWeight: 400,
  },
  top: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    justifyContent: "center",
    padding: `0px ${pxToRem(AppSize.padding)}`,
    [theme.breakpoints.down(600)]: {
      display: "flex",
      padding: `0px ${pxToRem(20)}`,
    },
  },
  drop: {
    display: "flex",
    // gridTemplateColumns: "repeat(6,2fr)",
    gap: theme.spacing(4),
    height: pxToRem(106),
    alignItems: "center",
    padding: theme.spacing(3),
    marginBottom: pxToRem(-10),
  },
  dropCont: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    gap: pxToRem(10),
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  btn: {
    height: pxToRem(46),
    borderRadius: pxToRem(8),
    width: pxToRem(150),
    alignSelf: "center",
    justifySelf: "end",
  },
  divider: {
    height: pxToRem(40),
    borderWidth: 1.7,
    borderStyle: "solid",
    borderColor: AppColors.neutral[85],
  },
  selectName: {
    fontSize: pxToRem(20),
    fontWeight: 500,
    color: AppColors.text.default,
    [theme.breakpoints.down(1360)]: {
      fontSize: pxToRem(17),
      lineHeight: "160%",
    },
  },
  foot: {
    padding: `0px ${pxToRem(AppSize.padding)}`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    [theme.breakpoints.down(860)]: {
      display: "none",
    },
  },
  mobileNav: {
    display: "none",
    [theme.breakpoints.down(860)]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: `0px ${pxToRem(AppSize.padding)}`,
    },
    [theme.breakpoints.down(600)]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: `0px ${pxToRem(20)}`,
    },
  },
  mobile: {
    width: "100%",
  },
}));
